import React from "react"
import Page from "../common/page"
import ProductContent from "../../components/products/product-content"
import ProductsList from "../../components/products/products-list"
import SEO from "../seo"

const Product = props => {
  const pageData = props.pageContext.pageData
  const productSlug = pageData.slug

  if (!pageData) return null

  if (productSlug) {
    return (
      <ProductContent
        product={pageData}
        showRatings={props?.pageContext?.isEn}
        categorySlug={props?.pageContext?.categorySlug}
      />
    )
  } else {
    return (
      <Page page={pageData}>
        <ProductsList
          products={props.pageContext.products}
          isSmallVersion={true}
          showRatings={props?.pageContext?.isEn}
        />
      </Page>
    )
  }
}

export default Product

export const Head = ({ location, pageContext }) => (
  <SEO
    pathname={location.pathname}
    title={pageContext.pageData.title}
    schemaData={pageContext.pageData}
    showRatings={pageContext.isEn}
    pageContext={pageContext}
  />
)
